import axios from "axios";
import { logoutHandler } from "../utils/auth/logout";
// Dev mac 3.21.57.79
// QC mac  3.16.132.179

// const BE_IP = "3.21.57.79";

// const LICENSE_URL = `https://${BE_IP}:8099/api`;
// const ARCHIVAL_MANAGEMENT_URL = `https://${BE_IP}:8098/api`;
// const ARCHIVAL_SEARCH_URL = `https://${BE_IP}:8097/api`;
// const BANK_SETTINGS = `https://${BE_IP}:8096/api`;
// // const ALERT_NOTIFICATION = `https://${BE_IP}:8095/api`;
// const REPORTING = `https://${BE_IP}:8066/api`;
// const ALERTS = `https://${BE_IP}:8095/api`;
// const NOTIFICATION = `https://${BE_IP}:8094/api`;

const headers = {
  accept: `*/*`,
  "Content-Type": "application/json",
};

const archivalManagementHeaders = {
  accept: `*/*`,
  "Content-Type": "application/json",
};

const archivalSearchHeaders = {
  accept: `*/*`,
  "Content-Type": "application/json",
};

const bankSettingsHeaders = {
  accept: `*/*`,
  "Content-Type": "application/json",
};

const alertHeader = {
  accept: `*/*`,
  "Content-Type": "application/json",
};

const notificationHeader = {
  accept: `*/*`,
  "Content-Type": "application/json",
};

const customerFileHeader = {
  accept: `*/*`,
  "Content-Type": "multipart/form-data",
  
};
const MatchingHeader = {
  accept: `*/*`,
  "Content-Type": "application/json",
};
const reportingHeader = {
  accept: `*/*`,
  "Content-Type": "application/json",
};

const licenseApi = axios.create({
  baseURL: window.config.LICENSE_URL,
  timeout: 0,
  headers: headers,
});

const archivalManagementApi = axios.create({
  baseURL: window.config.ARCHIVAL_MANAGEMENT_URL,
  timeout: 0,
  headers: archivalManagementHeaders,
});

const archivalSearchApi = axios.create({
  baseURL: window.config.ARCHIVAL_SEARCH_URL,
  timeout: 0,
  headers: archivalSearchHeaders,
});

const bankSettingsApi = axios.create({
  baseURL: window.config.BANK_SETTINGS,
  timeout: 0,
  headers: bankSettingsHeaders,
});

const alertsApi = axios.create({
  baseURL: window.config.ALERTS,
  timeout: 0,
  headers: alertHeader,
});

const customerFileApi = axios.create({
  baseURL:window.config.CUSTOMER_FILE,
  timeout:0,
  headers:customerFileHeader
})
const notificationApi = axios.create({
  baseURL: window.config.NOTIFICATION,
  timeout: 0,
  headers: notificationHeader,
});

const matchingApi = axios.create({
  baseURL: window.config.MATCHING,
  timeout: 0,
  headers: MatchingHeader,
});

const reportingApi = axios.create({
  baseURL: window.config.REPORTING,
  timeout: 0,
  headers: reportingHeader,
});

const setupAuth = (licenseKey, token) => {
  [
    bankSettingsApi,
    archivalSearchApi,
    archivalManagementApi,
    alertsApi,
    notificationApi,
    matchingApi,
    reportingApi,
    customerFileApi
  ].forEach((api) =>
    api.interceptors.request.use((config) => {
      config.headers["license-key"] = licenseKey;
      config.headers["token"] = token;
      return config;
    })
  );
};

const setupInterceptors = (store, keycloak) => {
  const { dispatch } = store;

  //Get warnning messages
  [
    licenseApi,
    alertsApi,
    customerFileApi,
    notificationApi,
    archivalManagementApi,
    archivalSearchApi,
    bankSettingsApi,
    reportingApi,
    matchingApi,
  ].forEach((api) =>
    api.interceptors.response.use(
      (response) => {
        //Unlock license if the response code isn't included in the list of locking ones (in case it was locked)

        //Show warnings in all cases
        if (
          [
            "LICENSE_WARNING",
            "LICENSE_LOCK",
            "LICENSE_ERROR",
            "LICENSE_LOGOUT",
          ].includes(response.data?.responseCode) &&
          response.data?.licenseMessage
        ) {
          dispatch({
            type: "SET_WARNING_MESSAGE",
            payload: { message: response.data.licenseMessage },
          });
        }

        switch (response.data?.responseCode) {
          case "LICENSE_LOCK": //Daily band exceeded
          case "LICENSE_ERROR": //License expired or license not found (license hasn't been activated before)
            dispatch({
              type: "LOCK_LICENSE",
              payload: true,
            });
            break;

          //Concurrent users exceeded
          case "LICENSE_LOGOUT":
            setTimeout(() => {
              logoutHandler(
                keycloak.logout,
                keycloak.tokenParsed["license-key"]
              );
            }, 1000);
            break;

          default:
            break;
        }

        return Promise.resolve(response);
      },
      (error) => {
        return Promise.resolve(error.response);
      }
    )
  );
};

export {
  licenseApi,
  archivalManagementApi,
  reportingApi,
  archivalSearchApi,
  bankSettingsApi,
  alertsApi,
  customerFileApi,
  notificationApi,
  matchingApi,
  setupAuth,
  setupInterceptors,
};
